import { ellipsis } from 'ellipsed';

// adding some <i> via js for fontawesome icons
var icons = [
    {
        selector: '#portal-breadcrumbs > .container ol.breadcrumb li:first-child a',
        icon: 'fas fa-home',
        prepend: true,
    },
    {
        selector: '#document-toc .portletHeader',
        icon: 'fas fa-list-ul',
        prepend: true,
    },
    {
        selector: '#parent-fieldname-text.pat-autotoc .autotoc-nav a',
        icon: 'fas fa-chevron-right',
        prepend: true,
    },
    {
        selector:
            '.template-album_view .photoAlbumEntry.photoAlbumFolder .photoAlbumEntryTitle',
        icon: 'fas fa-folder-open',
        prepend: true,
    },
    {
        selector: '#search-filter-toggle',
        icon: 'fas fa-filter',
        prepend: true,
    },
    {
        selector: '#searchform div.d-flex.mb-2 .nav-item.dropdown:last-child > a:first-of-type',
        icon: 'fas fa-arrow-up-short-wide',
        prepend: true,
    },
    {
        selector: '#sorting-options a[data-sort="Date"]',
        icon: 'far fa-calendar-alt',
        prepend: true,
    },
    {
        selector: '#sorting-options a[data-sort="sortable_title"]',
        icon: 'fas fa-sort-alpha-down',
        prepend: true,
    },
    {
        selector:
            '#sorting-options a:not([data-sort="Date"]):not([data-sort="sortable_title"])',
        icon: 'fas fa-star',
        prepend: true,
    },
    {
        selector: '#categories-filed-under',
        icon: 'fas fa-tags',
        prepend: true,
    },
    {
        selector:
            '#portal-searchbox input:not(.solr-search) + button.searchButton, #portal-searchbox input:not(.solr-search) + button.search-button',
        icon: 'bi bi-search',
        prepend: true,
    },
    {
        selector:
            '#searchform .input-group .input-group-btn',
        icon: 'bi bi-search',
        prepend: true,
    },
    {
        selector: '.viewlet-document-actions #document-action-print a',
        icon: 'fas fa-print',
        prepend: true,
    },
    {
        selector: 'nav.pagination ul li .arrow',
        icon: 'fas fa-angle-right',
        prepend: false,
    },
    {
        selector: 'article.vevent a.event_ical',
        icon: 'far fa-calendar',
        prepend: true,
    },
    {
        selector: '.event.summary.details li.event-calendar a',
        icon: 'far fa-calendar',
        prepend: true,
    },
    {
        selector: '#document-action-csv_export a',
        icon: 'fas fa-file-lines',
        prepend: true,
    },
    {
        selector: '#document-action-xls_export a',
        icon: 'fas fa-file-excel',
        prepend: true,
    },
];

$(document).ready(function () {
    // init fontawesome icons
    icons.forEach(function (i) {
        var $el = $(i.selector);

        if ($el.length === 0) {
            return;
        }

        if (i.prepend) {
            $el.prepend('<i class="' + i.icon + '"></i>');
        } else {
            $el.append('<i class="' + i.icon + '"></i>');
        }
    });

    function normalizeImageMarkup() {
        var knownImages = [
            {
                match: '/++plone++uniba.theme6/unibalogo.svg',
                width: '270',
                height: '80',
                alt: null,
            },
            {
                match: '/@@site-logo/',
                width: '350',
                height: '80',
                alt: null,
            },
            {
                match: '/images/ico-facebook.svg',
                width: '30',
                height: '30',
                alt: '',
                linkLabel: 'Facebook UniBa',
            },
            {
                match: '/images/ico-instagram.svg',
                width: '30',
                height: '30',
                alt: '',
                linkLabel: 'Instagram UniBa',
            },
            {
                match: '/images/ico-twitter.svg',
                width: '30',
                height: '30',
                alt: '',
                linkLabel: 'X UniBa',
            },
            {
                match: '/images/ico-youtube.svg',
                width: '30',
                height: '30',
                alt: '',
                linkLabel: 'YouTube UniBa',
            },
            {
                match: '/images/ico-linkedin.svg',
                width: '30',
                height: '30',
                alt: '',
                linkLabel: 'LinkedIn UniBa',
            },
            {
                match: '/images/uniba.it.svg',
                width: '72',
                height: '19',
                alt: 'uniba.it',
            },
            {
                match: '/images/ateneo.svg',
                width: '24',
                height: '20',
                alt: '',
            },
        ];

        function findKnownImage(src) {
            var i;

            for (i = 0; i < knownImages.length; i += 1) {
                if (src.indexOf(knownImages[i].match) !== -1) {
                    return knownImages[i];
                }
            }
            return null;
        }

        $('img').each(function () {
            var img = this;
            var src = img.getAttribute('src') || '';
            var matched = findKnownImage(src);
            var $link;

            if (!matched) {
                return;
            }

            if (!img.getAttribute('width')) {
                img.setAttribute('width', matched.width);
            }
            if (!img.getAttribute('height')) {
                img.setAttribute('height', matched.height);
            }
            if (!img.getAttribute('decoding')) {
                img.setAttribute('decoding', 'async');
            }
            if (!img.hasAttribute('alt')) {
                if (matched.alt !== null) {
                    img.setAttribute('alt', matched.alt);
                } else if (img.getAttribute('title')) {
                    img.setAttribute('alt', img.getAttribute('title'));
                }
            }
            if (matched.linkLabel) {
                $link = $(img).closest('a');
                if ($link.length && !$link.attr('aria-label')) {
                    $link
                        .attr('aria-label', matched.linkLabel)
                        .attr('title', matched.linkLabel);
                }
            }
        });
    }

    function normalizeSearchButtonMarkup() {
        $('button.searchButton, button.search-button, #portal-searchbox button[type="submit"]')
            .attr('aria-label', 'Cerca')
            .attr('title', 'Cerca')
            .each(function () {
                if (!$(this).text().trim()) {
                    $(this).append('<span class="hiddenStructure">Cerca</span>');
                }
            });
    }

    function normalizeNamelessInteractiveMarkup() {
        $('button').each(function () {
            var button = this;
            var $button = $(button);
            var label;

            if ($button.text().trim() || button.getAttribute('aria-label')) {
                return;
            }

            label =
                button.getAttribute('title') ||
                button.getAttribute('value') ||
                button.getAttribute('name') ||
                '';

            if (!label && $button.is('.searchButton, .search-button')) {
                label = 'Cerca';
            }

            if (label) {
                button.setAttribute('aria-label', label);
                $button.append(
                    $('<span></span>')
                        .addClass('hiddenStructure')
                        .text(label)
                );
            }
        });

        $('a').each(function () {
            var link = this;
            var $link = $(link);
            var label;
            var imgAlt;
            var href;

            if ($link.text().trim() || link.getAttribute('aria-label')) {
                return;
            }

            imgAlt = $link.find('img[alt]').first().attr('alt');
            href = link.getAttribute('href') || '';
            label =
                link.getAttribute('title') ||
                (imgAlt && imgAlt.trim()) ||
                link.getAttribute('data-link-label') ||
                '';

            if (!label && href && href !== '#') {
                label = href
                    .replace(/^mailto:/, '')
                    .replace(/^https?:\/\//, '')
                    .replace(/\/$/, '');
            }

            if (label) {
                link.setAttribute('aria-label', label);
                return;
            }

            if (!href || href === '#') {
                link.setAttribute('aria-hidden', 'true');
                link.setAttribute('tabindex', '-1');
            }
        });
    }

    normalizeImageMarkup();
    normalizeSearchButtonMarkup();
    normalizeNamelessInteractiveMarkup();

    $(document).on('rtTilesLoaded shown shown.bs.modal', function () {
        normalizeImageMarkup();
        normalizeSearchButtonMarkup();
        normalizeNamelessInteractiveMarkup();
    });

    /*
     *  return-to-top arrow
     */
    $(window).scroll(function () {
        if ($(this).scrollTop() >= 50) {
            $('#return-to-top').fadeIn(200);
        } else {
            $('#return-to-top').fadeOut(200);
        }
    });

    $('#return-to-top').click(function () {
        $('body,html').animate(
            {
                scrollTop: 0,
            },
            500
        );
    });

    /*
     *  share button position
     */
    var $share = $('.share');
    if ($('.news-column').length) {
        $('.news-column').prepend($share);
        $share.addClass('share-visible');
    } else if ($('#portal-column-two').length) {
        $('#portal-column-two').prepend($share);
        $share.addClass('share-visible');
    }

    /*
     * share button behavior
     */
    $('.share .share-toggle').on('click', function (e) {
        e.preventDefault();
        $share.toggleClass('open');
    });

    $('.uniba-topbar__list > li > .unibaheader-toggle').on('click', function () {
        var $item = $(this).closest('li');
        var $siblings = $item.siblings();

        $siblings
            .removeClass('open')
            .children('.unibaheader-toggle')
            .removeClass('show')
            .attr('aria-expanded', 'false');

        $siblings
            .children('.unibaheader_collapse')
            .removeClass('show');
    });

    function closeMobileMenu() {
        $('#mobile-menu-wrapper')
            .removeClass('open')
            .attr('aria-hidden', 'true');
        $('#mobile-menu-toggle')
            .removeClass('open')
            .attr('aria-expanded', 'false');
        $('body').removeClass('mobileMenuOpened');
    }

    function closeMobileMenuItem($item) {
        var animationDuration = getMobileMenuAnimationDuration();

        $item
            .removeClass('mobile-submenu-open')
            .children('.mobile-submenu-toggle')
            .attr('aria-expanded', 'false')
            .attr('aria-label', 'Apri sottomenu')
            .attr('title', 'Apri sottomenu')
            .find('.mobile-submenu-toggle-sign')
            .text('');

        $item
            .children('.mobile-submenu-panel')
            .attr('aria-hidden', 'true')
            .stop(true, true)
            .slideUp(animationDuration);

        $item.find('li.mobile-submenu-open').each(function () {
            closeMobileMenuItem($(this));
        });
    }

    function getMobileMenuAnimationDuration() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 0
            : 220;
    }

    function scrollMobileMenuToItem($item) {
        var $menu = $('#mobile-menu-wrapper');

        if (!$menu.length || !$item.length || !$menu.hasClass('open')) return;

        var menuElement = $menu.get(0);
        var itemTop = $item.offset().top;
        var menuTop = $menu.offset().top;
        var scrollPadding = 12;
        var targetScroll =
            $menu.scrollTop() + itemTop - menuTop - scrollPadding;
        var maxScroll = menuElement.scrollHeight - $menu.innerHeight();

        targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));

        if (getMobileMenuAnimationDuration() === 0) {
            $menu.scrollTop(targetScroll);
            return;
        }

        $menu.stop(true).animate({ scrollTop: targetScroll }, 180);
    }

    function updateMobileMenuPosition() {
        var $header = $('#portal-header');

        if (!$header.length) return;

        var menuTop = Math.max(
            0,
            $header.offset().top + $header.outerHeight() - $(window).scrollTop()
        );

        document.documentElement.style.setProperty(
            '--mobile-menu-top',
            menuTop + 'px'
        );
    }

    function syncMobileNavigationState() {
        var stateClasses = ['inPath', 'current', 'selected', 'active'];
        var $desktopItems = $('#portal-globalnav-wrapper #portal-globalnav li');
        var $mobileItems = $('#mobile-menu-wrapper > #portal-globalnav li');

        if (!$desktopItems.length || !$mobileItems.length) return;

        $desktopItems.each(function (index) {
            var desktopItem = this;
            var mobileItem = $mobileItems.get(index);

            if (!mobileItem) return;

            stateClasses.forEach(function (className) {
                $(mobileItem).toggleClass(
                    className,
                    $(desktopItem).hasClass(className)
                );
            });
        });
    }

    function watchDesktopNavigationState() {
        var desktopNav = document.querySelector(
            '#portal-globalnav-wrapper #portal-globalnav'
        );

        if (!desktopNav || !window.MutationObserver) return;

        var observer = new MutationObserver(function (mutations) {
            var shouldSync = mutations.some(function (mutation) {
                return (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'class'
                );
            });

            if (shouldSync) {
                syncMobileNavigationState();
            }
        });

        observer.observe(desktopNav, {
            attributes: true,
            attributeFilter: ['class'],
            subtree: true,
        });
    }

    function normalizeMobileServicesMenu() {
        var $panel = $('.mobile-menu-servizionline .unibaheader_collapse--servizionline');

        if (!$panel.length || $panel.children('ul.mobile-servizionline-sections').length) {
            return;
        }

        var $content = $panel.children('div').first();
        var $columns = $content.children('div');
        var $sections = $('<ul class="mobile-servizionline-sections"></ul>');

        $columns.each(function () {
            var $column = $(this);
            var $heading = $column.children('h3').first();
            var $links = $column.children('ul').first();

            if (!$heading.length || !$links.length) return;

            var $section = $('<li class="nav-item mobile-utility-submenu"></li>');
            $('<a href="#"></a>').text($heading.text().trim()).appendTo($section);
            $section.append($links);
            $sections.append($section);
        });

        var $allServices = $panel.children('div.row').find('a').first();
        if ($allServices.length) {
            $('<li class="nav-item"></li>').append($allServices).appendTo($sections);
        }
        $panel.children('div.row').remove();

        if ($sections.children().length) {
            $content.replaceWith($sections);
        }
    }

    function initMobileMenuAccordion() {
        var $menu = $('#mobile-menu-wrapper');

        if (!$menu.length || $menu.data('mobileAccordionReady')) return;

        normalizeMobileServicesMenu();
        $menu.data('mobileAccordionReady', true);

        $menu.find('li').each(function (index) {
            var $item = $(this);
            var $submenu = $item
                .children('ul, .dropdown-menu, .unibaheader_collapse')
                .first();
            var $link = $item.children('a').first();

            if (!$submenu.length || !$link.length) return;

            var panelId =
                $submenu.attr('id') || 'mobile-menu-panel-' + index.toString();
            var isUtilitySubmenu = $submenu.hasClass('unibaheader_collapse');

            $item.addClass('has-mobile-submenu');
            if (isUtilitySubmenu) {
                $item.addClass('mobile-utility-submenu');
                $submenu.find('a').each(function () {
                    var $emptyLink = $(this);
                    if (!$emptyLink.text().trim() && !$emptyLink.children().length) {
                        $emptyLink.addClass('mobile-empty-link');
                    }
                });
            }
            $submenu
                .addClass('mobile-submenu-panel')
                .attr('id', panelId)
                .attr('aria-hidden', 'true')
                .hide();

            if ($item.children('.mobile-submenu-toggle').length) return;

            $(
                '<button type="button" class="mobile-submenu-toggle" aria-expanded="false">' +
                '<span class="mobile-submenu-toggle-sign" aria-hidden="true"></span>' +
                '<span class="sr-only">Apri sottomenu</span>' +
                '</button>'
            )
                .attr('aria-controls', panelId)
                .attr('aria-label', 'Apri sottomenu')
                .attr('title', 'Apri sottomenu')
                .insertAfter($link);
        });

        $menu.on('click', '.mobile-utility-submenu > a', function (e) {
            e.preventDefault();
            e.stopPropagation();

            $(this)
                .siblings('.mobile-submenu-toggle')
                .first()
                .trigger('click');
        });

        $menu.on('click', '.mobile-submenu-toggle', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $toggle = $(this);
            var $item = $toggle.closest('li');
            var $panel = $item.children('.mobile-submenu-panel').first();
            var isOpen = $item.hasClass('mobile-submenu-open');
            var animationDuration = getMobileMenuAnimationDuration();

            $item.siblings('.mobile-submenu-open').each(function () {
                closeMobileMenuItem($(this));
            });

            if (isOpen) {
                closeMobileMenuItem($item);
                return;
            }

            $item.addClass('mobile-submenu-open');
            $toggle
                .attr('aria-expanded', 'true')
                .attr('aria-label', 'Chiudi sottomenu')
                .attr('title', 'Chiudi sottomenu')
                .find('.mobile-submenu-toggle-sign')
                .text('');
            $panel
                .attr('aria-hidden', 'false')
                .stop(true, true)
                .css({ display: 'block', height: 0, overflow: 'hidden' });

            var panelHeight = $panel.get(0).scrollHeight;
            $panel.animate({ height: panelHeight }, animationDuration, function () {
                $panel.css({ height: 'auto', overflow: '' });
                scrollMobileMenuToItem($item);
            });
        });
    }

    function closeMobileSearch() {
        $('#portal-searchbox').removeClass('open');
        $('#search-toggle').removeClass('open');
        $('body').removeClass('searchOpened');
    }

    /*
     * mobile: search button action
     */
    $('#search-toggle').on('click', function () {
        closeMobileMenu();
        $('#portal-searchbox').toggleClass('open');
        $('#search-toggle').toggleClass('open');
        $('body').toggleClass('searchOpened');

        if ($('#portal-searchbox').hasClass('open')) {
            $('#searchGadget').focus();
        }
    });

    /*
     * mobile: menu toggle click
     */
    initMobileMenuAccordion();
    syncMobileNavigationState();
    watchDesktopNavigationState();
    setTimeout(syncMobileNavigationState, 0);
    setTimeout(syncMobileNavigationState, 250);
    setTimeout(syncMobileNavigationState, 1000);

    $('#mobile-menu-toggle').on('click', function () {
        var isOpen = !$('#mobile-menu-wrapper').hasClass('open');

        closeMobileSearch();
        updateMobileMenuPosition();
        $('#mobile-menu-wrapper')
            .toggleClass('open', isOpen)
            .attr('aria-hidden', isOpen ? 'false' : 'true');
        $('#mobile-menu-toggle')
            .toggleClass('open', isOpen)
            .attr('aria-expanded', isOpen ? 'true' : 'false');
        $('body').toggleClass('mobileMenuOpened', isOpen);
    });

    $('#globalnav-close').click(function () {
        $('#portal-mainnavigation').removeClass('open');
        $('#portal-globalnav-collapse').removeClass('in');
        closeMobileMenu();
    });

    /*
     * gestione click fuori per chiudere menu, ricerca e condividi
     */
    $(document).on('click', function (e) {
        if (
            !$(e.target).closest('#portal-searchbox').length &&
            !$(e.target).closest('button#search-toggle').length &&
            $(window).width() <= 991
        ) {
            $('#portal-searchbox').removeClass('open');
            $('#search-toggle').removeClass('open');
            $('body').removeClass('searchOpened');
        }

        if (!$(e.target).closest('.share').length) {
            $share.removeClass('open');
        }

        if (
            !$(e.target).closest('#mobile-menu-wrapper').length &&
            !$(e.target).closest('#mobile-menu-toggle').length &&
            $(window).width() <= 991
        ) {
            closeMobileMenu();
        }
    });

    $(window).on('resize', function () {
        if ($('#mobile-menu-wrapper').hasClass('open')) {
            updateMobileMenuPosition();
        }
    });


    function callEllipsis() {
        ellipsis(
            '.tile-collection .collectionItemDescription, .news-highlight .news-description, .news-big-photo .news-description',
            4,
            {
                responsive: true,
            }
        );
    }

    /*
     * On tiles loaded:
     * - gestito tabIndex news collection collapse
     * - multi lined ellipsis for news collection items
     */
    if ($('body').hasClass('userrole-anonymous')) {
        callEllipsis();
    } else {
        $('.tiles-management, .pat-tiles-management').on(
            'rtTilesLoaded',
            function () {
                callEllipsis();
            }
        );
    }

    $(document).on('patSliderInit', function (e) {
        $(e.originalEvent.detail)
            .find('.slick-dots')
            .attr('aria-hidden', true);
    });

    var isIE = /*@cc_on!@*/ false || !!document.documentMode;
    if (!isIE) {
        var iconsEvent = new Event('rtIconsLoaded');
        document.dispatchEvent(iconsEvent);
    }

    /*
     * Update breadcrumbs when navigating in folder content
     * Patch paired with https://github.com/plone/mockup/issues/1016
     * Should be paired with plone.staticresources 1.4.0 for full resolution
     */
    $(document).on('click', function (e) {
        if ($(e.target).closest('.pat-structure').length > 0) {
            $('#portal-breadcrumbs').load(
                window.location.href.split('folder_contents')[0] +
                ' #portal-breadcrumbs',
                function () {
                    $('#portal-breadcrumbs #breadcrumbs-home a').prepend(
                        '<i class="fas fa-home"></i>'
                    );
                }
            );
            //$('h1.documentFirstHeading').load(
            //window.location.href.split('folder_contents')[0] +
            //' h1.documentFirstHeading'
            //);
        }
    });
});
